'use client';
import { kebabCase } from 'lodash';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';

interface Venue {
  team: string;
  city: string;
  state: string;
  venue: string;
  league: string;
}

interface Props {
  venues: Venue[];
}

export const SpringTrainingVenues = ({ venues }: Props) => {
  const searchParams = useSearchParams();
  const partnerSlugParam = searchParams?.get('partnerSlug');
  const getUrl = (team: string) => {
    // 75894 - SPRING TRAINING
    const params = new URLSearchParams();

    if (partnerSlugParam) {
      params.set('partnerSlug', partnerSlugParam);
    }

    params.set('opponentId', '75894');

    const query = params.toString();

    return `/events/mlb/spring-training/${kebabCase(team)}${query ? `?${query}` : ''}`;
  };

  if (!venues.length) return null;

  return (
    <div>
      <h2 className="mb-8 text-2xl font-bold text-gray-800">All teams</h2>
      <div className="grid w-full auto-rows-max grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {venues.map((venue) => {
          return (
            <div
              key={venue.team}
              className="rounded-lg border border-gray-200 bg-white p-4"
            >
              <Link
                prefetch={false}
                href={getUrl(venue.team)}
                className="block"
              >
                <h3 className="mb-2 text-base font-semibold text-gray-800 hover:text-blue-600">
                  {venue.team}
                </h3>
                <p className="text-sm text-gray-600">
                  {venue.city}, {venue.state}
                </p>
                <p className="mt-1 text-xs text-gray-500">{venue.venue}</p>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};
